// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore'
import {getAuth} from 'firebase/auth'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAOIvx1kwl2YH7etbh6p5GaU81YDUrec38",
  authDomain: "todo-app-v2-93309.firebaseapp.com",
  projectId: "todo-app-v2-93309",
  storageBucket: "todo-app-v2-93309.appspot.com",
  messagingSenderId: "803636940603",
  appId: "1:803636940603:web:75fb87621706be469ff11e",
  measurementId: "G-G92JMV20GZ"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore();

export const auth = getAuth(app)

export default db